import React, { useState } from "react";
import { Buttons } from "bnb-ui/dist";
import DialogBnb from "../DialogBnb";
import { Paper } from "@material-ui/core";

export interface PropsExternOut {
	realizarLogout: Function;
}

const ExternOut: React.FC<PropsExternOut> = (props: PropsExternOut) => {
	const [open, setOpen] = useState(true);

	function handleOut(): void {
		setOpen(false);
		props.realizarLogout();
	}

	return (
		<Paper>
			<DialogBnb
				open={open}
				type={"atencao"}
				text={"O email cadastrado não consta na base de dados do SISTEC. " + "Favor contactar a CEST responsável para atualização do cadastro."}
				buttons={
					<Buttons variant="contained" color="secondary" onClick={(): void => handleOut()} autoFocus>
						VOLTAR PARA O LOGIN
					</Buttons>
				}
			/>
		</Paper>
	);
};
export default ExternOut;
